// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

export const LegendItemRoot = styled.li<{ isVertical: boolean }>`
  display: flex;
  align-items: center;
  min-width: 0;

  &:not(:first-of-type) {
    margin-top: ${({ isVertical }) => (isVertical ? "0.25rem" : "")};
    margin-left: ${({ isVertical }) => (isVertical ? "" : "0.75rem")};
  }
`;

export const LegendItemLabel = styled.div`
  --legend-item-hover-color: var(--mb-color-text-brand-strong-hover);

  display: flex;
  align-items: center;
  width: 100%;

  &:hover {
    color: ${({ onMouseEnter }) =>
      onMouseEnter && "var(--legend-item-hover-color)"};
  }
`;

export const LegendItemDotContainer = styled.div<{ isMuted: boolean }>`
  display: flex;
  opacity: ${({ isMuted }) => (isMuted ? "0.4" : "1")};
  transition: opacity 0.25s linear;
`;

const LEGEND_ITEM_TITLE_MARGIN = 4;

export const LegendItemTitle = styled.div<{
  dotSize: string;
  isMuted: boolean;
  isInsidePopover?: boolean;
}>`
  color: ${({ isMuted }) =>
    isMuted
      ? "var(--mb-color-text-secondary-opaque)"
      : "var(--mb-color-text-primary)"};
  font-size: 0.928em;
  font-weight: 700;
  margin-left: ${LEGEND_ITEM_TITLE_MARGIN}px;
  overflow: hidden;
  transition: color 0.25s linear;
  cursor: ${({ onClick }) => (onClick ? "pointer" : "")};
  max-width: ${({ dotSize, isInsidePopover }) =>
    isInsidePopover
      ? `calc(100% - ${dotSize}px - ${LEGEND_ITEM_TITLE_MARGIN}px)`
      : "unset"};

  &:hover {
    color: ${({ onClick }) => onClick && "var(--legend-item-hover-color)"};
  }
`;
